import template from './expense-wizard.html';
import controller from './expense-wizard.controller';

let expenseWizardComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default expenseWizardComponent;



// WEBPACK FOOTER //
// ./client/pages/expenses/expense-wizard/expense-wizard.component.js